import React from "react";

import { NOOP } from "core/constants";
import RoundQuantityButton from "core/Components/Buttons/QuantityButton/RoundQuantityButton";

type Props = {
    className?: string,
    quantity: number,
    maxQuantity: number,
    minQuantity?: number,
    buttonSize?: number,
    backgroundColour?: string,
    onPlusIconClick: (e: React.MouseEvent) => void,
    onMinusIconClick: (e: React.MouseEvent) => void,
    onCustomQuantity: (quantity: React.ChangeEvent<HTMLInputElement>) => void,
    addToCartHandler?: () => void,
};

const QuantityPlusMinusButton: React.FC<Props> = (
    {
        className = '',
        quantity,
        maxQuantity,
        minQuantity = 1,
        buttonSize = undefined,
        backgroundColour = undefined,
        onPlusIconClick,
        onMinusIconClick,
        onCustomQuantity,
        addToCartHandler = NOOP,
    }
) => (
    <RoundQuantityButton
        className={className}
        quantity={quantity}
        maxQuantity={maxQuantity}
        minQuantity={minQuantity}
        buttonSize={buttonSize}
        plusClickHandler={onPlusIconClick}
        minusClickHandler={onMinusIconClick}
        onAddToCart={addToCartHandler}
        onChange={onCustomQuantity}
        backgroundColour={backgroundColour}
    />
);

export default QuantityPlusMinusButton;